import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, className = "", showNumber = false, count }) => {
  const rounded = Math.round(value * 2) / 2;
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid="star-rating">
      <span className="inline-flex">
        {[1, 2, 3, 4, 5].map((i) => {
          const filled = i <= Math.floor(rounded);
          const half = !filled && i - 0.5 === rounded;
          return (
            <Star
              key={i}
              size={size}
              className={filled || half ? "fill-amber-400 text-amber-400" : "text-slate-300 dark:text-slate-600"}
            />
          );
        })}
      </span>
      {showNumber && (
        <span className="text-sm font-semibold text-foreground">
          {value ? value.toFixed(1) : "—"}
          {typeof count === "number" && (
            <span className="text-muted-foreground font-normal"> ({count})</span>
          )}
        </span>
      )}
    </span>
  );
};
